import styled, { css } from 'styled-components';
import { maxWidth } from '@/assets/styles/mixins.css.js';
import vars from '@/assets/styles/vars';
import Container from './StyledContainer';
import Widget from './StyledWidget';
import Nav from './StyledNav';

const NavPanel = styled.div`
  position: sticky;
  z-index: 3;
  top: 0;
  width: 100%;
  background: var(--color-light);
  border-bottom: 1px solid rgba(var(--color-border-rgb), 0.5);
  padding-top: 20px;
  margin-top: -15px;

  ${Widget} {
      opacity:0;
      visibility:hidden;
      transition:0s;
  }

  ${(props) =>
    props.scrolled &&
    css`
      ${Widget} {
          opacity:1;
          visibility:visible;
      }
    `}

  ${maxWidth(vars.breakpoints.tablet)`
    top: 61px;
    border-bottom: none;
    margin: 0;
    padding: 0;
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    top: 61px;
  `}
`;

NavPanel.Container = styled(Container)`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  ${Nav} {
    ${maxWidth(vars.breakpoints.tablet)`
      display: none;
    `}
  }
`;

NavPanel.Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
  transform:translateY(-5px);
  flex-shrink: 0;

  & > * {
    flex-shrink: 0;
  }

  ${maxWidth(vars.breakpoints.tablet)`
    display:none;
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    top: -52px;
  `}
`;

NavPanel.Search = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 23px;
  height: 23px;
  color: var(--color-decor);
  flex-shrink: 0;

  ${maxWidth(vars.breakpoints.tablet)`
    display:none;
  `}

  ${(props) =>
    props.active &&
    css`
      display: none;
    `}
`;

export default NavPanel;
